import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

import { STORY_URL } from "../constants/ApiEndpointConstants";

export const getCommentListAPI = (id) => {
  return api.post(`${STORY_URL}` + `${ApiEndpointConstants.COMMENT_LIST}`, {
    tieziid: id,
  });
};
